"use client";

import { useEffect } from "react";
import { recordTripVisit } from "@/app/lib/myTrips";

// Invisible — records this itinerary into the visitor's local "My Trips"
// list on mount. Rendered from both show/[city] and show/[city]/[itineraryid]
// pages so any itinerary a visitor lands on is remembered.
export default function RecordTripVisit({
  city,
  itinid,
  cityName,
}: {
  city: string;
  itinid: string;
  cityName: string;
}) {
  useEffect(() => {
    recordTripVisit({ city, itinid, cityName });
  }, [city, itinid, cityName]);

  return null;
}
